// extracted by mini-css-extract-plugin
module.exports = {"header":"userHeader_header__3UfNa","logo":"userHeader_logo__3ho8l"};